var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCancel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 5.4C4 3.59835 5.40423 2 7.31339 2H12.3425C13.3927 2 14.4567 2.39181 15.2604 3.19084L15.2701 3.2005L18.8866 6.89605C19.6883 7.6965 20.0956 8.86897 19.9809 9.95712V18.6C19.9809 20.4017 18.5767 22 16.6675 22H7.31339C5.40423 22 4 20.4017 4 18.6V5.4ZM7.31339 4C6.60742 4 6 4.60165 6 5.4V18.6C6 19.3983 6.60742 20 7.31339 20H16.6675C17.3735 20 17.9809 19.3983 17.9809 18.6V9.9C17.9809 9.8583 17.9835 9.81663 17.9888 9.77525C18.0504 9.28456 17.8563 8.69202 17.4712 8.30916L17.4615 8.2995L13.8459 4.60483C13.443 4.20669 12.8996 4 12.3425 4H7.31339Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 14C8 13.4477 8.44772 13 9 13H15C15.5523 13 16 13.4477 16 14C16 14.5523 15.5523 15 15 15H9C8.44772 15 8 14.5523 8 14Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 17C8 16.4477 8.44772 16 9 16H12C12.5523 16 13 16.4477 13 17C13 17.5523 12.5523 18 12 18H9C8.44772 18 8 17.5523 8 17Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancel);
export default __webpack_public_path__ + "static/media/cancel.8e79d02c179ea77ac12cc73143aeb2e9.svg";
export { ForwardRef as ReactComponent };